import React from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import arrowRightImg from '../../assets/image/go3@3x.png'
import defaultHead from '../../assets/image/ic_default_avatar.png';
import LazyLoadImg from '../aelComponent/LazyLoadImg';
import utils from 'bxl-utils';

const CommentSecondItem = (props) => {
  const { descendants, descendantsNum, index2, clickToComment, toSecondComment, type, parentIndex } = props
  let descendantsItem = descendants.comment
  let flag = true;
  if ((!descendantsNum || (type === 'secondPageList') || ((((index2 + 1) !== descendantsNum * 1) && (index2 + 1) !== 2)))) {
    flag = false
  }

  return (
    <div className='CommentSecondItem'
      data-type={descendantsItem.id}
      data-pid='commentSecondItem' data-index={index2}
    >
      <div className='commentHeader'
        onClick={clickToComment.bind(this, { commentId: descendantsItem.id, name: descendantsItem.userLabel, index: parentIndex })}>
        <div className='commentHeadImgBox'>
          <LazyLoadImg image={descendantsItem.userAvatar || defaultHead} alt={descendantsItem.userLabel || 'user comment avatar'} className='commentHeadImg' />
        </div>
        <div className='userName'>{descendantsItem.userLabel}</div>
        <div className='commentTime'>{utils.formatter.format(+descendantsItem.postedAt, 'MM-DD HH:mm')}</div>
      </div>
      <div className='commentInfo'
        onClick={clickToComment.bind(this, { commentId: descendantsItem.id, name: descendantsItem.userLabel, index: parentIndex })}>
        <div className={`replayBox ${(index2 + 1) === descendantsNum || (index2 + 1) === 2 ? 'notLast' : ''}`}>
          回复 <span className='replayName'>{descendantsItem.parentUserLabel}：</span>{descendantsItem.content}
        </div>
      </div>
      {
        flag && < div className='seeMore' onClick={toSecondComment}>
          查看更多({descendantsNum}条）<img src={arrowRightImg} alt="see more icon" />
        </div>
      }

    </div>
  )
}

CommentSecondItem.propTypes = {
  descendants: PropTypes.object,
  descendantsNum: PropTypes.number,
  index2: PropTypes.number,
  clickToComment: PropTypes.func
}
export default CommentSecondItem